module.exports = __webpack_public_path__ + "img/cat_src.45923e9e.png";